<template>
	<aside>
		<compFormEdit
			col="1"
			ref="accountform"
			class="margin-layout"
			:formdata="getBase"
			v-model="formData"
		></compFormEdit>
		<vButtonGroup class="text-right margin-top-15">
			<vButton theme="primary" @click="submit">{{$t('global.modal.confirm', { defaultValue: "确定" })}}</vButton>
			<vButton @click="close">{{$t('global.common.cancel', { defaultValue: "取消" })}}</vButton>
		</vButtonGroup>
		<vLoading size="large" fix :loading="loading"></vLoading>
	</aside>
</template>
<script>
import { HttpShipManageList } from '@/service/billing';
import { HttpSaveAdjustPayAccount, HttpBillSummaryList } from '@/service/chargescalc';
import { HttpGetBillTotalList } from '@/service/newbigaccount';
import { mapGetters } from 'vuex';
import mixin from '../mixin';
export default {
	mixins: [mixin],
	components: {
		compWrapper: () => import('@components/templates/wrapper'),
		compFormEdit: () => import('@components/templates/formedit'),
	},
	data() {
		return {
			loading: false,
			formData: {},
			billList: [],
		};
	},
	created() {
		// this.getReconList()
	},
	computed: {

        ...mapGetters('dictionary', ['getBillcusWareList', 'getBillcusorgList']),
		getBase() {
			return [
                // {
                //     label: '账单类型',
                //     tag: 'vSelect',
                //     key: 'billType',
				// 	options: [
                //         { value: 0, label: '库内作业'},
                //         { value: 1, label: '尾程'},
                //     ],
                //     on: {
                //         'on-change': this.getReconList
                //     }
                // },
				// {
				// 	label: this.$t('fbb.billmanage.bill_no', { defaultValue: '账单编号' }),
				// 	tag: 'vSelect',
				// 	key: 'billNo',
				// 	options: this.billList,
				// 	on: {
				// 		'on-attach': attach => this.formData = { ...this.formData, ...attach }
				// 	},
				// 	props: {
                //         filterable: true,
                //     }
				// },
                {
					label: this.$t('fbb.billmanage.bill_no', { defaultValue: '账单编号' }),
					key: 'billNo',
					on: {
                        'on-blur': (val) => {
                            this.setBillNo(val)
                        }
					},
				},
				{
					label: '仓库',
					key: 'warehouseCode',
					query: true,
				},
				{
					label: this.$t('fbb.billmanage.bill_date', { defaultValue: '月份' }),
					key: 'month',
					query: true,
				},
				{
					label: this.$t('fbb.adjustment.type', { defaultValue: '调账类型' }),
					tag: 'vSelect',
					key: 'type',
					options: this.getAdjutmentType
				},
				{
					label: this.$t('fbb.adjustment.bill_type', { defaultValue: '费用类型' }),
					tag: 'vSelect',
					key: 'billingType',
					options: this.getCostType,
				},
                {
					label: this.$t('fbb.inbound.client_organization', { defaultValue: "客户" }),
					key: 'organizationId',
					tag: 'vSelect',
                    options:this.getBillcusorgList,
                    props:{
                        filterable:true,
                    }
				},
				{
					label:  this.$t('fbb.adjustment.bill_no', { defaultValue: '计费单号' }),
					tag: 'vInput',
					key: 'billingOrderNo',
					required: false,
				},
                // {
                //     label: '仓库',
                //     tag: 'vSelect',
                //     key: 'warehouseId',
                //     options: this.getBillcusWareList,
                //     props:{
                //         filterable:true,
                //     },
                //     required: false,
                //     // query:this.type!='add',
                // },
				{
					label: this.$t('fbb.adjustment.amount', { defaultValue: '调账金额' }),
					tag: 'vInputNumber',
					key: 'amount',
					span: 22,
					props:{
						min:0
					}
				},
				{
					tag: 'div',
					labelWidth: 5,
					children: 'USD',
					query: true,
					span: 2,
				},
				{
					label: this.$t('fbb.adjustment.remark', { defaultValue: '调账说明' }),
					tag: 'vTextarea',
					key: 'remark',
				},
			]
		},

	},
	methods: {
        async setBillNo(val){
            if(!val.trim()) return
			this.loading = true
            await HttpBillSummaryList({'search[EQ_billNo]':val}).then( res =>{
                this.loading = false;
                const result = res.data.content;
                if(result.length == 0){
                    this.$VMessage.error('账单不存在');
                    this.formData.billNo = '';
                    this.formData.organizationName = '';
                    this.formData.warehouseCode = '';
                    this.formData.month = '';
                    this.formData.organizationId = '';
                    this.formData.orgWarehouseId = '';
                    this.formData.warehouseId = '';
                    return;
                }
                let attach = {
                    organizationName: result[0].organizationName,
                    warehouseCode: result[0].warehouseCode,
                    month: result[0].startTime+"~"+result[0].endTime,
                    organizationId: result[0].organizationId,
                    orgWarehouseId: result[0].orgWarehouseId,
                    warehouseId: result[0].warehouseId,
                };
                this.formData = { ...this.formData, ...attach };
            },err => {
                this.loading = false
                this.$VMessage.error(err.message);
            })
        },
		// getReconList() {
		// 	this.loading = true
        //     // if(this.formData.billType == 0 ){
        //     //     HttpGetBillTotalList({
        //     //         page: 1,
        //     //         rows: 1000,
        //     //         sidx: 'id',
        //     //         sord: 'desc',
        //     //         'search[EQ_status]': 0
        //     //         }).then(res => {
        //     //             this.loading = false
        //     //             this.billList = res.data.content.map(item => {
        //     //                 return {
        //     //                     value: item.billNo,
        //     //                     label: item.billNo,
        //     //                     attach: {
        //     //                         organizationName: item.organizationName,
        //     //                         warehouseCode: item.warehouseCode,
        //     //                         month: item.startTime+"~"+item.endTime,
        //     //                         organizationId: item.organizationId,
        //     //                         orgWarehouseId: item.orgWarehouseId,
        //     //                         warehouseId: item.warehouseId,
        //     //                     }
        //     //                 }
        //     //         })
        //     //     }, err => {
        //     //         this.loading = false
        //     //         this.$VMessage.error(err.message);
        //     //     })
        //     // }else if(this.formData.billType == 1 ) {
        //         HttpBillSummaryList({
        //             page: 1,
        //             rows: 1000,
        //             sidx: 'id',
        //             sord: 'desc',
        //             'search[EQ_status]': 0
        //         }).then(res => {
		// 		this.loading = false
		// 		this.billList = res.data.content.map(item => {
		// 			return {
		// 				value: item.billNo,
		// 				label: item.billNo,
		// 				attach: {
		// 					organizationName: item.organizationName,
		// 					warehouseCode: item.warehouseCode,
		// 					month: item.startTime+"~"+item.endTime,
		// 					organizationId: item.organizationId,
		// 					orgWarehouseId: item.orgWarehouseId,
		// 					warehouseId: item.warehouseId,
		// 				}
		// 			}
		// 		})
        //         }, err => {
        //             this.loading = false
        //             this.$VMessage.error(err.message);
        //         })
        //     // }
		// },
		close() {
			this.$emit('on-close')
		},
		async submit() {
			const valid = await this.$refs['accountform'].validate();
			if (!valid) return;
			this.loading = true
			HttpSaveAdjustPayAccount({hostOrganizationId:global.SYSID,...this.formData}).then(res => {
				this.$VMessage.success(res.message);
				this.close();
				this.$emit('on-update');
			}, err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		}
	}
};
</script>
